import { DEFAULT_GETTERS } from '@/constants'

export default {
  ...DEFAULT_GETTERS,

  accountPartnero: state => state.accountPartnero,
}
